import * as z$1 from "zod/v4";
//#region src/schemas/daemon/mention-dispatch-result.ts
const OPENMELD_DAEMON_MENTION_DISPATCH_RESULT_SCHEMA_VERSION = 2;
const openMeldDaemonMentionDispatchStatusSchema = z$1.enum([
	"dispatch_ready",
	"blocked",
	"failed"
]);
const openMeldDaemonMentionDispatchRuleSourceSchema = z$1.enum([
	"system",
	"space",
	"profile",
	"registry"
]);
const openMeldDaemonMentionDispatchResultCommonPayloadSchema = z$1.strictObject({
	sourceEventId: z$1.string().min(1),
	dispatchId: z$1.string().min(1),
	targetProfileId: z$1.string().min(1),
	ruleSource: openMeldDaemonMentionDispatchRuleSourceSchema,
	ruleId: z$1.string().min(1),
	ruleReason: z$1.string().min(1)
});
const openMeldDaemonMentionDispatchReadyPayloadSchema = openMeldDaemonMentionDispatchResultCommonPayloadSchema.extend({ status: z$1.literal("dispatch_ready") });
const openMeldDaemonMentionDispatchBlockedPayloadSchema = openMeldDaemonMentionDispatchResultCommonPayloadSchema.extend({
	status: z$1.literal("blocked"),
	errorCode: z$1.string().min(1)
});
const openMeldDaemonMentionDispatchFailedPayloadSchema = openMeldDaemonMentionDispatchResultCommonPayloadSchema.extend({
	status: z$1.literal("failed"),
	errorCode: z$1.string().min(1)
});
const openMeldDaemonMentionDispatchResultPayloadSchema = z$1.discriminatedUnion("status", [
	openMeldDaemonMentionDispatchReadyPayloadSchema,
	openMeldDaemonMentionDispatchBlockedPayloadSchema,
	openMeldDaemonMentionDispatchFailedPayloadSchema
]);
const openMeldDaemonMentionDispatchResultEnvelopeSchema = z$1.strictObject({
	v: z$1.literal(2),
	code: z$1.literal("service.mention_dispatch_result"),
	payload: openMeldDaemonMentionDispatchResultPayloadSchema
});
//#endregion
export { OPENMELD_DAEMON_MENTION_DISPATCH_RESULT_SCHEMA_VERSION, openMeldDaemonMentionDispatchResultEnvelopeSchema, openMeldDaemonMentionDispatchResultPayloadSchema, openMeldDaemonMentionDispatchRuleSourceSchema, openMeldDaemonMentionDispatchStatusSchema };

//# sourceMappingURL=mention-dispatch-result.js.map